import { render, staticRenderFns } from "./SocialMediaLinks.vue?vue&type=template&id=be1837f4&scoped=true&"
import script from "./SocialMediaLinks.js?vue&type=script&lang=js&"
export * from "./SocialMediaLinks.js?vue&type=script&lang=js&"
import style0 from "./SocialMediaLinks.scss?vue&type=style&index=0&id=be1837f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1837f4",
  null
  
)

export default component.exports